export default __webpack_public_path__ + "static/media/map.fe1924c4.png";